import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f1bkinpani: FaireBrandEntity = {
  token: "b_f1bkinpani",
  type: "brand",
  name: "NYSLIFE",
  avatarUrl:
    "https://cdn.faire.com/fastly/83497a5a8a986d7ff305a37e081a54cc535e94c1760e118880bdd51322240ae5.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c4de580a82dc6a5fff729c0b02a129942cb833e1d14ae7093946b95b5b741145.png",
  logoUrl:
    "https://cdn.faire.com/fastly/83497a5a8a986d7ff305a37e081a54cc535e94c1760e118880bdd51322240ae5.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c4de580a82dc6a5fff729c0b02a129942cb833e1d14ae7093946b95b5b741145.png",
  location: "Morganville , NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 29,
  isInsider: true,
  description:
    "NYSLIFE is a company created by a pair of lifelong friends, Sal and Marc. They shared a passion for innovative and affordable style. The origin of their business began in the basement of a Brooklyn apartment back in '96. Their first endeavor was a kiosk in the iconic World Trade center in the heart of New York City. Each customer, each interaction, inspired them to continue on their entrepreneurial path. \n\nAs demand for their quality products grew, they expanded to retail stores and malls in their home state of New York. Then every state in the U.S. and more than 50 countries.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:09.903Z",
    importedBy: "entity-db-cli",
  },
};
